import Vue from 'vue'
import Router from 'vue-router'

// components
import JmenoMazlicka from '@/components/01JmenoMazlicka'
import Rasa from '@/components/02Rasa'
import Fotografie from '@/components/03Fotografie'
import Narozeniny from '@/components/04Narozeniny'
import Pohlavi from '@/components/05Pohlavi'
import HmotnostKondice from '@/components/06HmotnostKondice'
import Pohyb from '@/components/07Pohyb'
import Alergie from '@/components/08Alergie'
import Suroviny from '@/components/09Suroviny'
import HotoveKrmivo from '@/components/10HotoveKrmivo'
import p404 from '@/components/P404'

Vue.use(Router)

export default new Router({
    linkActiveClass: 'active',
    linkExactActiveClass: '',
    routes: [
        {
            path: '*',
            name: '404',
            component: p404
        },
        {
            path: '/',
            name: 'jmenomazlicka',
            component: JmenoMazlicka
        },
        {
            path: '/rasa',
            name: 'rasa',
            component: Rasa
        },
        {
            path: '/fotografie',
            name: 'fotografie',
            component: Fotografie
        },
        {
            path: '/narozeniny',
            name: 'narozeniny',
            component: Narozeniny
        },
        {
            path: '/pohlavi',
            name: 'pohlavi',
            component: Pohlavi
        },
        {
            path: '/hmotnost-kondice',
            name: 'hmotnostkondice',
            component: HmotnostKondice
        },
        {
            path: '/pohyb',
            name: 'pohyb',
            component: Pohyb
        },
        {
            path: '/alergie',
            name: 'alergie',
            component: Alergie
        },
        {
            path: '/suroviny',
            name: 'suroviny',
            component: Suroviny
        },
        {
            path: '/hotove-krmivo',
            name: 'hotovekrmivo',
            component: HotoveKrmivo
        }
    ],
})



// WEBPACK FOOTER //
// ./src/router/index.js